export const supportsDateInput = () => {
  const input = document.createElement(`input`)
  input.setAttribute(`type`, `date`)

  const notADateValue = `not-a-date`
  input.setAttribute(`value`, notADateValue)

  return !(input.value === notADateValue)
}

export default function LabeledDate(el) {
  el.toggleAttribute("data-has-value", (el.value || "").trim())

  el.addEventListener("change", () => {
    el.toggleAttribute("data-has-value", !!(el.value || "").trim())
  })
}
